import {useHistory, useParams} from "react-router-dom";
import {DashboardLayout} from "components/Layout";
import {SubmitButton} from "components/Button";
import {CircleLoader} from "components/Loader";
import {FormCard} from "components/Form";
import {useDetailMedicineUnit} from "hooks/SuperAdmin/MedicineUnit";

export function MedicineUnitDetailPage() {
	const history = useHistory();
	const {id} = useParams();
	const {data: detailMedicineUnit, isLoading: loadingFetcing} = useDetailMedicineUnit(id);

	if (loadingFetcing) {
		return (
			<DashboardLayout>
				<FormCard backTitle="Daftar list unit obat" title="Detail Unit Obat">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<FormCard
				backTitle="Daftar List Unit Obat"
				title={`Detail Data Unit Obat ${detailMedicineUnit?.data?.name}`}
				onBackButtonClick={() => history.push("/unit-obat")}>
				<div class="row gx-2 mb-5">
					<div class="col-sm-6 col-6">
						<div class="setting-item">
							<label class="setting-label ">Nama Unit Obat</label>
							<p className="text-bold text-grey">{detailMedicineUnit?.data?.name}</p>
						</div>
					</div>
				</div>

				<div class="text-center my-3">
					<SubmitButton
						className="btn btn-orange d-inline-block mw-250"
						text="Ubah Data Ini"
						onClick={() => history.push(`/unit-obat/edit/${detailMedicineUnit?.data?.id}`)}
					/>
				</div>
			</FormCard>
		</DashboardLayout>
	);
}
